import { useWindowDimensions } from './useWindowDimensions';
import { DeviceType } from '../constants/device';
import { getDeviceType } from '../helpers/device';

export const useDeviceType = (): DeviceType => {
  const { width } = useWindowDimensions();

  return getDeviceType(width);
};
